import React from "react"

const MyTimesheetsContainer = React.lazy(
  () => import("~/MyTimesheets/MyTimesheetsContainer"),
)

export default MyTimesheetsContainer
